import React from "react";
import Topbar from "../layout/Topbar";
import SettingsSidebar from "../settings/SettingsSidebar";
import Members from "./Members";
import {Box, CssBaseline, List, ListItemButton, ListItemText, useTheme} from "@mui/material";
import {NavLink} from "react-router-dom";
import Workspaces from "../workspace/Workspaces";
import {SettingsContentBox, SettingsRoot} from "../settings/General";
import {settingsPageStyles, SettingsPageHeader} from "../settings/SettingsDesign";

function Team(props) {
    const theme = useTheme();
    return (
        <SettingsRoot>
            <CssBaseline/>
            <Topbar/>
            <SettingsSidebar {...props}/>
            <SettingsContentBox sx={settingsPageStyles}>
                <Box display="flex" flexDirection="column" flexWrap="noWrap" sx={{
                    width: "100%",
                    padding: "24px 30px 0 30px",
                    maxWidth: "1280px",
                    minWidth: 0,
                    margin: "0 auto",
                    [theme.breakpoints.down(600)]: {
                        padding: "16px 0 0"
                    }
                }}>
                    <SettingsPageHeader title="Team"/>

                    <Box display="flex" className="settings-tabs">
                        <List sx={{display: 'flex', flexDirection: 'row', padding: 0}}>
                            <ListItemButton
                                component={NavLink}
                                to="/settings/team/members"
                                selected={props?.location?.pathname === "/settings/team/members"}
                                sx={{
                                    "&.Mui-selected": {
                                        backgroundColor: "background.defaultBlue",
                                        borderBottomWidth: "2px",
                                        borderBottomStyle: "solid",
                                        borderBottomColor: "primary.main",
                                        marginBottom: "-2px",
                                        ":hover": {
                                            backgroundColor: "background.rowHover"
                                        }
                                    },
                                    ":hover": {
                                        backgroundColor: "background.rowHover"
                                    }
                                }}
                            >
                                <ListItemText primary="Members" sx={{fontSize: 14, paddingLeft: 2, paddingRight: 2}}/>
                            </ListItemButton>
                            <ListItemButton
                                component={NavLink}
                                to="/settings/team/workspaces"
                                selected={props?.location?.pathname === "/settings/team/workspaces"}
                                sx={{
                                    "&.Mui-selected": {
                                        backgroundColor: "background.defaultBlue",
                                        borderBottomWidth: "2px",
                                        borderBottomStyle: "solid",
                                        borderBottomColor: "primary.main",
                                        marginBottom: "-2px",
                                        ":hover": {
                                            backgroundColor: "background.rowHover"
                                        }
                                    },
                                    ":hover": {
                                        backgroundColor: "background.rowHover"
                                    }
                                }}
                            >
                                <ListItemText
                                    primary="Workspaces"
                                    sx={{fontSize: 14, paddingLeft: 2, paddingRight: 2}}
                                />
                            </ListItemButton>
                        </List>
                    </Box>
                    <Box display="flex">
                        {props?.match?.isExact && props?.match?.path === "/settings/team/members" &&
                            <Members {...props}/>
                        }
                        {props?.match?.isExact && props?.match?.path === "/settings/team/workspaces" &&
                            <Workspaces {...props}/>
                        }
                    </Box>
                </Box>
            </SettingsContentBox>
        </SettingsRoot>
    );
}

export default Team;